import { Component, OnInit, HostListener, ViewChild, ChangeDetectorRef, AfterViewChecked } from '@angular/core';
import { Store } from '@ngrx/store';
import { ViewerActions } from 'app/trace-management/core/reducers/viewer.actions';
import { Subscription } from 'rxjs';
import { SecurityAuthenticationComponent } from './security-authentication/security-authentication.component';

@Component({
  selector: 'biz-security',
  templateUrl: './security.component.html',
  styleUrls: ['./security.component.scss']
})
export class SecurityComponent implements OnInit, AfterViewChecked  {

  authorizationActive = true;
  authenticationActive = false;
  ldapActive = false;

  @ViewChild('securityAuthentication', { static: false}) securityAuthentication: SecurityAuthenticationComponent;

  public tabs: any;
  private _tabsSubscription: Subscription;

  constructor(private _store: Store<INodes>,private _viewerActions: ViewerActions, private cdRef : ChangeDetectorRef) { }

  ngOnInit() {
    this._tabsSubscription = this._store
        .select((s) => s.menuOptions)
        .subscribe((menuOptions: any) => {
            this.tabs = menuOptions['Security'];
    });
  };

  ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }

  ngOnDestroy() {
      this._tabsSubscription.unsubscribe();
  }

  authorizationClicked() {
     this._store.dispatch(this._viewerActions.Activated('Authorization'));
  }

  authenticationClicked() {
    this._store.dispatch(this._viewerActions.Activated('Authentication'));
  }

  ldapClicked() {
    this._store.dispatch(this._viewerActions.Activated('LDAP'));
  }

}
